module.exports = __webpack_public_path__ + "media/images/scribe-textbook-4e586623.png";